import React from 'react';

export default function AboutSection() {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-grid">
          <div className="about-visual fade-up">
            <div className="about-visual-inner">
              <div className="about-ornament">🌿</div>
            </div>
            <div className="about-card">
              <div className="about-card-num">5K+</div>
              <div className="about-card-text">Years of<br />Ayurvedic<br />Wisdom</div>
            </div>
          </div>
          <div className="fade-up">
            <p className="section-label">Who We Are</p>
            <h2 className="section-title">
              Healing Through<br />Nature's <em>Intelligence</em>
            </h2>
            <p className="section-body">
              KayaSparsha is a dedicated Ayurvedic wellness clinic and Panchakarma centre
              at Kengeri Satellite Town, Bangalore. We bring authentic, physician-led
              Ayurvedic care to everyday life — for skin, body, and mind.
            </p>
            <div className="pillars">
              <div className="pillar">
                <div className="pillar-icon">🩺</div>
                <div className="pillar-text">
                  <h4>Doctor-Led Consultations</h4>
                  <p>Every treatment begins with Nadi Pariksha and Prakriti analysis by a qualified BAMS physician.</p>
                </div>
              </div>
              <div className="pillar">
                <div className="pillar-icon">🌿</div>
                <div className="pillar-text">
                  <h4>Authentic Formulations</h4>
                  <p>We use premium oils and medicines — never compromise on quality.</p>
                </div>
              </div>
              <div className="pillar">
                <div className="pillar-icon">🏠</div>
                <div className="pillar-text">
                  <h4>Calm, Hygienic Space</h4>
                  <p>A 1,200 sq. ft. purpose-built clinic with dedicated rooms for male and female patients — your comfort is our design.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
